'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _messages = require('common/messages');

var _account = require('./account.html');

var _account2 = _interopRequireDefault(_account);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _account2.default,
  bindings: {
    accessLevels: '<',
    user: '<'
  },
  controller: function () {
    function AccountComponent($mdDialog, $scope, $state, AccountService, ToastService) {
      'ngInject';

      _classCallCheck(this, AccountComponent);

      Object.assign(this, {
        $mdDialog: $mdDialog,
        $scope: $scope,
        $state: $state,
        AccountService: AccountService,
        ToastService: ToastService
      });
    }

    _createClass(AccountComponent, [{
      key: 'updateAccount',
      value: function updateAccount($event) {
        var _this = this;

        if ($event && $event.user) {
          this.AccountService.updateAccount($event.user).then(function () {
            _this.ToastService.showSuccess(_messages.ACCOUNT_EDITED);
            _this.$state.reload();
          }).catch(function (error) {
            return _this.ToastService.showError(error);
          });
        }
      }
    }, {
      key: 'showChangePassword',
      value: function showChangePassword() {
        var _this2 = this;

        var scope = _angular2.default.extend(this.$scope.$new(true), {
          passwordChanged: function passwordChanged($event) {
            return _this2.onPasswordChanged($event);
          }
        });

        this.$mdDialog.show({
          clickOutsideToClose: true,
          fullscreen: true,
          scope: scope,
          template: '\n          <md-dialog class="flex-50">\n            <md-dialog-content>\n              <dialog-close/>\n              <change-password password-changed="passwordChanged($event)">\n              </change-password>\n            </md-dialog-content>\n          </md-dialog>\n          '
        });
      }
    }, {
      key: 'onPasswordChanged',
      value: function onPasswordChanged($event) {
        var _this3 = this;

        if ($event && $event.credentials && this.user.UserId) {
          this.AccountService.forcePasswordChange(_extends({
            UserId: this.user.UserId
          }, $event.credentials)).then(function () {
            _this3.$mdDialog.hide();
            _this3.ToastService.showSuccess(_messages.PASSWORD_CHANGED);
          }).catch(function (error) {
            return _this3.ToastService.showError(error);
          });
        }
      }
    }]);

    return AccountComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/account/account.component.js